module.exports = __webpack_public_path__ + "static/media/python-intermediate.1850053b.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/levels/python-intermediate.png
// module id = 1472
// module chunks = 147